export const KiwiMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <circle cx="32" cy="32" r="31" fill="#6B4A2F" />
    <circle cx="32" cy="32" r="27" fill="#8CC63F" />
    <circle cx="32" cy="32" r="24" fill="#A5D64B" />
    <circle cx="32" cy="32" r="11" fill="#FDFBF7" />
    <g fill="#272B20">
      <ellipse cx="32" cy="18.5" rx="1.7" ry="3.2" />
      <ellipse cx="32" cy="45.5" rx="1.7" ry="3.2" />
      <ellipse cx="18.5" cy="32" rx="3.2" ry="1.7" />
      <ellipse cx="45.5" cy="32" rx="3.2" ry="1.7" />
      <ellipse cx="22.2" cy="22.2" rx="1.6" ry="3.1" transform="rotate(45 22.2 22.2)" />
      <ellipse cx="41.8" cy="22.2" rx="1.6" ry="3.1" transform="rotate(135 41.8 22.2)" />
      <ellipse cx="22.2" cy="41.8" rx="1.6" ry="3.1" transform="rotate(135 22.2 41.8)" />
      <ellipse cx="41.8" cy="41.8" rx="1.6" ry="3.1" transform="rotate(45 41.8 41.8)" />
    </g>
  </svg>
);
